function processMatrices(latexContent) {
  // Regular expression to match any LaTeX matrix type
  const matrixRegex = /\\begin{(pmatrix|bmatrix|vmatrix|Vmatrix|matrix|array)}([\s\S]*?)\\end{\1}/g;

  // Use a recursive approach to handle nested matrices
  function processMatrixContent(content) {
    return content.replace(matrixRegex, (match, matrixType, matrixContent) => {
      // Get the string between \begin{...} and \end{...}
      const innerContent = matrixContent;

      // Process line breaks specifically
      const lineBreakPlaceholder = "__LINE_BREAK__";
      let modifiedContent = innerContent.replace(/\\\\/g, lineBreakPlaceholder);

      // Define patterns that need special preservation in matrices
      const preservePatterns = [
        // Preserve internal placeholders FIRST
        /(__(?:PLACEHOLDER|PRESERVED|SPECIAL|DFRAC_EVAL|MATRIX_PLACEHOLDER)_\d+__)/g,


        // Matrix begin/end commands
        /(\\begin\{(?:pmatrix|bmatrix|vmatrix|Vmatrix|matrix|array)\})/g,
        /(\\end\{(?:pmatrix|bmatrix|vmatrix|Vmatrix|matrix|array)\})/g,

        // Math operators and symbols
        /(\\cdots|\\vdots|\\ddots|\\ldots)/g,
        /(\\ast|\\star|\\pm|\\mp|\\times|\\div)/g,
        /(\\circ|\\bullet|\\oplus|\\ominus|\\otimes)/g,
        /(\\cap|\\cup|\\wedge|\\vee|\\dagger)/g,
        /(\\langle|\\rangle|\\lfloor|\\rfloor|\\lceil|\\rceil)/g,

        // ADD THIS LINE - Greek letters
        /(\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega))/g,

        // Math functions
        /(\\(?:sin|cos|tan|log|ln|exp|sqrt|mathbf|mathrm|mathit|mathcal|mathbb|mathfrak))/g,


        // Other important math commands inside matrices
        /(\\(?:frac|dfrac|tfrac|cfrac|sfrac)\{(?:[^{}]|(?:\{[^{}]*\}))*\}\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,
        /(\\sqrt\{[^{}]*\})/g,
        /(\\text\{[^{}]*\})/g,

        // Subscripts and superscripts
        /([_^]\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g
      ];

      // Create a placeholder map
      const placeholderMap = new Map();
      let counter = 0;

      // Replace all patterns that need to be preserved with placeholders
      preservePatterns.forEach(pattern => {
        modifiedContent = modifiedContent.replace(pattern, (match) => {
          const placeholder = `__PRESERVED_${counter}__`;
          placeholderMap.set(placeholder, match);
          counter++;
          return placeholder;
        });
      });

      // Now handle backslashes - but only double those that aren't part of preserved commands
      modifiedContent = modifiedContent.replace(/\\/g, "\\\\");

      // Restore all preserved patterns
      placeholderMap.forEach((value, placeholder) => {
        modifiedContent = modifiedContent.replace(placeholder, value);
      });

      // Restore line breaks
      modifiedContent = modifiedContent.replace(new RegExp(lineBreakPlaceholder, 'g'), "\\\\");

      // Return the properly formatted matrix
      return `\\begin{${matrixType}}${modifiedContent}\\end{${matrixType}}`;
    });
  }

  // Handle nested matrices by processing multiple times
  let result = latexContent;
  const MAX_NESTING_DEPTH = 3;

  for (let i = 0; i < MAX_NESTING_DEPTH; i++) {
    result = processMatrixContent(result);
  }

  return result;
}



function containsMatrix(content) {
  const matrixPattern = /\\begin{(pmatrix|bmatrix|vmatrix|Vmatrix|matrix|array)}/;
  return matrixPattern.test(content);
}

function replaceMap(str) {
  return str
    // .replace(/\\mathrm/g, "\\text")

    .replace(/\\"/g, "\\ddot{a}")
    .replace(/\\'/g, "\\acute{a}")
    .replace(/\\\//g, "\\slash")
    .replace(/\\=/g, "\\overline{a}")
    .replace(/\\Colon/g, "\\mathbin{:}")
    .replace(/\\Laplace/g, "\\mathscr{L}")
    .replace(/\\Lbag/g, "\\langle")
    .replace(/\\Longmapsfrom/g, "\\longleftarrow")
    .replace(/\\Longmapsto/g, "\\longrightarrow")
    .replace(/\\MapsTo/g, "\\rightarrow")
    .replace(/\\Mapsfrom/g, "\\leftarrow")
    .replace(/\\Rbag/g, "\\rangle")
    .replace(/\\Yup/g, "\\checkmark")
    .replace(/\\^/g, "\\hat{a}")
    .replace(/\\`/g, "\\grave{a}")
    .replace(/\\backdoubleprime/g, "\\prime\\prime")
    .replace(/\\biconditional/g, "\\leftrightarrow")
    .replace(/\\biginterleave/g, "\\parallel")
    .replace(/\\boxast/g, "\\square\\mkern-5mu\\ast")
    .replace(/\\boxbar/g, "\\square\\mkern-5mu\\vert")
    .replace(/\\boxbox/g, "\\square\\square")
    .replace(/\\boxbslash/g, "\\square\\mkern-5mu\\backslash")
    .replace(/\\boxcircle/g, "\\square\\mkern-5mu\\circ")
    .replace(/\\boxslash/g, "\\square\\mkern-5mu/")
    .replace(/\\capitalDifferentialD/g, "\\mathrm{D}")
    .replace(/\\differencedelta/g, "\\Delta")
    .replace(/\\differentialD/g, "\\mathrm{d}")
    .replace(/\\divides/g, "\\mid")
    .replace(/\\doubleStruckCapitalN/g, "\\mathbb{N}")
    .replace(/\\doubleStruckCapitalP/g, "\\mathbb{P}")
    .replace(/\\doubleStruckCapitalQ/g, "\\mathbb{Q}")
    .replace(/\\doubleStruckCapitalR/g, "\\mathbb{R}")
    .replace(/\\doubleStruckCapitalZ/g, "\\mathbb{Z}")
    .replace(/\\doubleprime/g, "\\prime\\prime")
    .replace(/\\enskip/g, "\\;")
    .replace(/\\eqdef/g, "\\triangleq")
    .replace(/\\error/g, "Error")
    .replace(/\\exponentialE/g, "\\mathrm{e}")
    .replace(/\\fatsemi/g, "\\mathbin{;}")
    .replace(/\\fontfamily/g, "\\mathrm{text}")
    .replace(/\\fontseries/g, "\\mathbf{text}")
    .replace(/\\fontshape/g, "\\mathit{text}")
    .replace(/\\gothicCapitalC/g, "\\mathfrak{C}")
    .replace(/\\gothicCapitalH/g, "\\mathfrak{H}")
    .replace(/\\gothicCapitalI/g, "\\mathfrak{I}")
    .replace(/\\gothicCapitalR/g, "\\mathfrak{R}")
    .replace(/\\hspace\*/g, "\\hspace{1em}")
    .replace(/\\imaginaryI/g, "\\mathrm{i}")
    .replace(/\\imaginaryJ/g, "\\mathrm{j}")
    .replace(/\\intclockwise/g, "\\oint")
    .replace(/\\intctrclockwise/g, "\\oint")
    .replace(/\\interleave/g, "\\parallel")
    .replace(/\\laplace/g, "\\mathcal{L}")
    .replace(/\\lb/g, "\\lbrace")
    .replace(/\\leftarrowtriangle/g, "\\triangleleft\\mkern-2mu\\leftarrow")
    .replace(/\\leftrightarrowtriangle/g, "\\triangleleft\\mkern-2mu\\leftrightarrow\\mkern-2mu\\triangleright")
    .replace(/\\leftslice/g, "/")
    .replace(/\\lightning/g, "\\triangle")
    .replace(/\\longmapsfrom/g, "\\longleftarrow")
    .replace(/\\mVert/g, "\\lVert\\rVert")
    .replace(/\\mapsfrom/g, "\\leftarrow")
    .replace(/\\mathbfit/g, "\\mathbf{\\mathit{x}}")
    .replace(/\\measeq/g, "\\cong")
    .replace(/\\mvert/g, "\\lvert\\rvert")
    .replace(/\\nicefrac/g, "\\frac{a}{b}")
    .replace(/\\nor/g, "\\downarrow")
    .replace(/\\nsubset/g, "\\not\\subset")
    .replace(/\\nsupset/g, "\\not\\supset")
    .replace(/\\ointctrclockwise/g, "\\oint")
    .replace(/\\ordinarycolon/g, "\\colon")
    .replace(/\\originalof/g, "\\cong")
    .replace(/\\overarc/g, "\\overparen{x}")
    .replace(/\\overunderset/g, "\\overset{a}{\\underset{b}{c}}")
    .replace(/\\pdiff/g, "\\partial")
    .replace(/\\questeq/g, "\\overset{?}{=}")
    .replace(/\\rD/g, "\\mathrm{D}")
    .replace(/\\rd/g, "\\mathrm{d}")
    .replace(/\\rightarrowtriangle/g, "\\rightarrow\\mkern-2mu\\triangleright")
    .replace(/\\rightslice/g, "\\backslash")
    .replace(/\\rmfamily/g, "\\mathrm{text}")
    .replace(/\\roundimplies/g, "\\Rightarrow")
    .replace(/\\scriptCapitalE/g, "\\mathcal{E}")
    .replace(/\\scriptCapitalH/g, "\\mathcal{H}")
    .replace(/\\scriptCapitalL/g, "\\mathcal{L}")
    .replace(/\\scshape/g, "\\text{\\scshape text}")
    .replace(/\\selectfont/g, "")
    .replace(/\\sffamily/g, "\\mathsf{text}")
    .replace(/\\slshape/g, "\\mathit{text}")
    .replace(/\\sslash/g, "\\slash\\slash")
    .replace(/\\stackbin/g, "\\overset{a}{b}")
    .replace(/\\talloblong/g, "\\parallel")
    .replace(/\\ttfamily/g, "\\mathtt{text}")
    .replace(/\\underarc/g, "\\underparen{x}")
    .replace(/\\varointclockwise/g, "\\oint")
    .replace(/\\placeholder/g, "\\Box")
    .replace(/\\~/g, "\\tilde{a}")
    .replace(/\\bigm\{\|\}/g, "\\mid")
    .replace(/\\bigm\{\|}/g, "\\mid")
    .replace(/\\bigm\|/g, "\\mid")
    .replace(/\\displaylines/g, "\\;")
    .replace(/\\middle\|/g, "|")
    .replace(/\\mid_\{([^{}]*)\}/g, "\\left.\\right|_{$1}")
    .replace(/(?<![\\a-zA-Z])\\mid(?![a-zA-Z])/g, "\\left|\\right")

    .replace(/\\quad/g, "  ")
  // .replace(/\\%/g, " mkar ")
}

// Escape underscores in text content
function escapeUnderscoresInText(content) {
  // Pattern to match \text{...} blocks
  const textBlockPattern = /\\text\{([^{}]*)\}/g;

  return content.replace(textBlockPattern, (match, textContent) => {
    // Escape underscores within the text content
    const escapedContent = textContent.replace(/_/g, '\\_');
    return `\\text{${escapedContent}}`;
  });
}



// Improved function to process LaTeX content that properly handles higher-order derivatives
function processLatex(content) {
  console.warn("content",content);
  
  if (!content) return content;


  // First, decode HTML entities in the content
  let processed = content
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");




  processed = processed.replace(/\\geq/g, "\\text{ ≥ }")
  processed = processed.replace(/\\ge/g, "\text{ ≥ }")

  // Escape standalone underscores that aren't part of subscripts
  processed = processed.replace(/\$\$([^$]*?)\$\$/g, (match, content) => {
    // Replace sequences of 3+ underscores with more escaped underscores
    const fixed = content.replace(/_{3,}/g, '\\_\\_\\_\\_\\_\\_\\_\\_\\_\\_');
    return `$$${fixed}$$`;
  });


  // // Handle plain square brackets containing LaTeX content - ADD THIS
  // processed = processed.replace(/\[\s*\n?\s*([^[\]]*\\[a-zA-Z]+[^[\]]*)\s*\n?\s*\]/g, (match, content) => {
  //   // Clean up the content and wrap with $$
  //   const cleanedContent = content
  //     .replace(/\n/g, ' ')    // Replace newlines with spaces
  //     .trim();                // Remove leading/trailing whitespace

  //   return `$$${cleanedContent}$$`;
  // });

  // Handle plain square brackets containing math content - UPDATED
  processed = processed.replace(/\[\s*\n\s*([^[\]]+)\s*\n\s*\]/g, (match, content) => {
    // Clean up the content and wrap with $$
    const cleanedContent = content
      .replace(/\n/g, ' ')    // Replace newlines with spaces
      .trim();                // Remove leading/trailing whitespace

    return `$$${cleanedContent}$$`;
  });




  processed = processed.replace(
    /(?<![\\a-zA-Z])\\mid(?![a-zA-Z_])/g,
    "|"
  );



  processed = processed.replace(/\\left\[/g, '\\bigl[');
  processed = processed.replace(/\\right\]/g, '\\bigr]');

  processed = processed.replace(/\\left\{/g, '{');
  processed = processed.replace(/\\right\}/g, '}');

  // Fix adjacent operators in mathematical expressions
  processed = processed.replace(/\$\$([^$]*?)\$\$/g, (match, latexContent) => {
    // Add spaces around < and > when they're adjacent to subscripts and \cdots
    let fixed = latexContent
      .replace(/([_}]\d+)</g, '$1 <')  // Add space after subscript before 
      .replace(/<(\\cdots)/g, '< $1')  // Add space before \cdots after 
      .replace(/(\\cdots)</g, '$1 <')  // Add space after \cdots before 
      .replace(/<([^\\s])/g, '< $1');  // Add space after < before other characters

    return `$$${fixed}$$`;
  });

  // Fix subscripts with LaTeX commands - add braces around them
  processed = processed.replace(
    /([a-zA-Z])_(\\[a-zA-Z]+)(?![{])/g,
    '$1_{$2}'
  );










  // Convert tfrac to regular frac
  processed = processed.replace(/\\tfrac/g, '\\frac');


  // processed = processed.replace(/%/g, ' ');

  processed = processed.replace(/\$\$([^$]*?)\$\$/g, (match, content) => {
    // Clean HTML tags from LaTeX content
    const cleanContent = content
      .replace(/%/gi, '\\text{percentage}')
    return `$$${cleanContent}$$`;
  });

  // Global delimiter conversions - convert manual sizing to automatic
  processed = processed.replace(/\\bigl\[/g, '\\left(');
  processed = processed.replace(/\\bigr\]/g, '\\right)');
  processed = processed.replace(/\\bigl\(/g, '\\left(');
  processed = processed.replace(/\\bigr\)/g, '\\right)');
  processed = processed.replace(/\\bigl\{/g, '{');
  processed = processed.replace(/\\bigr\}/g, '}');
  processed = processed.replace(/\\biggl\[/g, '\\left(');
  processed = processed.replace(/\\biggr\]/g, '\\right)');

  // ADD THESE LINES for capital B versions
  processed = processed.replace(/\\Bigl\[/g, '\\left(');
  processed = processed.replace(/\\Bigr\]/g, '\\right)');
  processed = processed.replace(/\\Bigl\(/g, '\\left(');
  processed = processed.replace(/\\Bigr\)/g, '\\right)');
  processed = processed.replace(/\\Bigl\{/g, '{');
  processed = processed.replace(/\\Bigr\}/g, '}');
  processed = processed.replace(/\\Biggl\[/g, '\\left(');
  processed = processed.replace(/\\Biggr\]/g, '\\right)');

  processed = processed.replace(/\\bigm\{\|\}/g, "|")
  processed = processed.replace(/\\bigm\{\|}/g, "|")
  processed = processed.replace(/\\bigm\|/g, "|")


  // With this comprehensive version:
  processed = processed.replace(/\\Bigl\{/g, '{');
  processed = processed.replace(/\\Bigr\}/g, '}');


  processed = processed.replace(/\\big/g, ' ');


  // Continue with your existing fixes...

  // Fix bracket notation in denominators globally
  processed = processed.replace(/\[([^[\]]+)\]\^([0-9]+)/g, '$1^$2');



  // Remove extra spacing commands that might cause issues
  processed = processed.replace(/\\!/g, ' '); // Convert negative space to regular space

  // Debug
  if (processed.includes('\\frac{d}{dx}')) {
  }




  // Fix single backslashes in LaTeX content - ONLY for line breaks, not LaTeX commands
  // This targeted fix handles single backslashes that are clearly line breaks in matrices

  // 1. Fix single backslashes followed by whitespace/newlines (matrix line breaks)
  // But exclude cases where the backslash is part of a LaTeX command
  processed = processed.replace(/(?<!\\)\\(?!\\|begin|end|text|frac|sqrt|sum|int|lim|sin|cos|tan|log|ln|exp|left|right|big|det|to|cdot|times|pm|mp|ast|star|circ|bullet|top|neq|leq|geq|ge|ni|wedge|exists|succeq|forall|angle|measuredangle|xrightarrow|sim|colon|sup|min|perp|lor|land|varepsilon|mid|prod|mapsto|widehat|vartheta|longleftrightarrow|lvert|rvert|propto|rho|le|vee|cfrac|overrightarrow|langle|varnothing|rangle|underbrace|binom|base|aleph|Longleftrightarrow|implies|dim|dfrac|gcd|varphi|div|bmod|lfloor|rfloor|triangle|dots|qquad|approx|equiv|subset|supset|substack|subseteq|supseteq|in|notin|cup|cap|setminus|emptyset|infty|partial|nabla|displaystyle|mathrm|mathbf|mathit|mathcal|mathbb|mathfrak|mathsf|boldsymbol|overline|underline|hat|bar|tilde|vec|dot|ddot|dddot|vdots|ddots|ldots|cdots|Longrightarrow|Leftarrow|Leftrightarrow|rightarrow|leftarrow|leftrightarrow|alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega)(\s*(?:\n|\r\n?)\s*)/g, '\\\\$1');

  // 2. Fix single backslashes followed by spaces within LaTeX blocks (matrix row separators)
  processed = processed.replace(/(\$\$[^$]*?)(?<!\\)\\(?!\\|begin|end|text|frac|sqrt|sum|int|lim|sin|cos|tan|log|ln|exp|left|right|Big|det|to|cdot|times|pm|mp|ast|star|circ|bullet|top|neq|leq|geq|ge|ni|wedge|exists|succeq|forall|angle|measuredangle|xrightarrow|sim|colon|sup|min|perp|lor|land|varepsilon|mid|prod|mapsto|widehat|vartheta|longleftrightarrow|lvert|rvert|propto|rho|le|vee|cfrac|overrightarrow|langle|varnothing|rangle|underbrace|binom|base|aleph|Longleftrightarrow|implies|dim|dfrac|gcd|varphi|div|bmod|lfloor|rfloor|triangle|dots|qquad|approx|equiv|subset|supset|substack|subseteq|supseteq|in|notin|cup|cap|setminus|emptyset|infty|partial|nabla|displaystyle|mathrm|mathbf|mathit|mathcal|mathbb|mathfrak|mathsf|boldsymbol|overline|underline|hat|bar|tilde|vec|dot|ddot|dddot|vdots|ddots|ldots|cdots|Longrightarrow|Leftarrow|Leftrightarrow|rightarrow|leftarrow|leftrightarrow|alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega)(\s+)([^$]*?\$\$)/g, '$1\\\\$2$3');

  // 3. Fix single backslashes at the end of lines or text within LaTeX blocks
  processed = processed.replace(/(\$\$[^$]*?)(?<!\\)\\(?!\\|begin|end|text|frac|sqrt|sum|int|lim|sin|cos|tan|log|ln|exp|left|right|big|det|to|cdot|times|pm|mp|ast|star|circ|bullet|top|neq|leq|geq|ge|ni|wedge|exists|succeq|forall|angle|measuredangle|xrightarrow|sim|colon|sup|min|perp|lor|land|varepsilon|mid|prod|mapsto|widehat|vartheta|longleftrightarrow|lvert|rvert|propto|rho|le|vee|cfrac|overrightarrow|langle|varnothing|rangle|underbrace|binom|base|aleph|Longleftrightarrow|implies|dim|dfrac|gcd|varphi|div|bmod|lfloor|rfloor|triangle|dots|qquad|approx|equiv|subset|supset|substack|subseteq|supseteq|in|notin|cup|cap|setminus|emptyset|infty|partial|nabla|displaystyle|mathrm|mathbf|mathit|mathcal|mathbb|mathfrak|mathsf|boldsymbol|overline|underline|hat|bar|tilde|vec|dot|ddot|dddot|vdots|ddots|ldots|cdots|Longrightarrow|Leftarrow|Leftrightarrow|rightarrow|leftarrow|leftrightarrow|alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega)(\s*)([^$]*?\$\$)/g, '$1\\\\$2$3');

  // 4. Fix single backslashes at the very end of text (not in LaTeX blocks)
  processed = processed.replace(/(?<!\\)\\(?!\\|begin|end|text|frac|sqrt|sum|int|lim|sin|cos|tan|log|ln|exp|left|right|big|det|to|cdot|times|pm|mp|ast|star|circ|bullet|top|neq|leq|geq|ge|ni|wedge|exists|succeq|forall|measuredangle|angle|xrightarrow|sim|colon|sup|min|perp|lor|land|varepsilon|mid|prod|mapsto|widehat|vartheta|longleftrightarrow|lvert|rvert|propto|rho|le|vee|cfrac|overrightarrow|langle|varnothing|rangle|underbrace|binom|base|aleph|Longleftrightarrow|implies|dim|dfrac|gcd|varphi|div|bmod|lfloor|rfloor|triangle|dots|qquad|approx|equiv|subset|supset|substack|subseteq|supseteq|in|notin|cup|cap|setminus|emptyset|infty|partial|nabla|displaystyle|mathrm|mathbf|mathit|mathcal|mathbb|mathfrak|mathsf|boldsymbol|overline|underline|hat|bar|tilde|vec|dot|ddot|dddot|vdots|ddots|ldots|cdots|Longrightarrow|Leftarrow|Leftrightarrow|rightarrow|leftarrow|leftrightarrow|alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega)$/g, '\\\\');

  // 5. Fix backslashes directly followed by digits 
  // BUT be careful to distinguish between:
  // - Matrix row separators (\3 in "2\3" should become "2\\")  
  // - Standalone digits (\5 in "text \5 more" should become "text 5 more")

  // Note: Matrix \digit fixing will be done later in the pipeline to avoid conflicts

  // 6. Clean HTML tags from within LaTeX blocks before processing
  // Remove <br>, <br/>, and other HTML tags that break LaTeX rendering
  processed = processed.replace(/\$\$([^$]*?)\$\$/g, (match, content) => {
    // Clean HTML tags from LaTeX content
    const cleanContent = content
      .replace(/<br\s*\/?>/gi, '\n')  // Replace <br> tags with newlines
      .replace(/<\/?[^>]+>/g, '')     // Remove any other HTML tags
      .replace(/\n+/g, ' ')           // Convert multiple newlines to single space
      .trim();                        // Remove leading/trailing whitespace
    return `$$${cleanContent}$$`;
  });

  // 7. Fix double backslashes before LaTeX commands (reduce \\command to \command)
  // This fixes cases where LaTeX commands have been double-escaped
  processed = processed.replace(/\\\\(neq|leq|geq|approx|equiv|subset|supset|subseteq|supseteq|in|notin|cup|cap|setminus|emptyset|text|infty|partial|nabla|displaystyle|mathrm|mathbf|mathit|mathcal|mathbb|mathfrak|boldsymbol|overline|underline|hat|bar|tilde|vec|dot|dots|ddot|dddot|vdots|ddots|ldots|cdots|rightarrow|leftarrow|leftrightarrow|Rightarrow|Leftarrow|Leftrightarrow)/g, '\\$1');

  // 8. Convert single $ delimiters to double $$ delimiters for consistency
  // This handles inline math expressions that use single $ instead of $$
  // Only convert if content contains LaTeX commands
  processed = processed.replace(/(?<!\$)\$(?!\$)([^$\n]*\\[a-zA-Z]+[^$\n]*)(?<!\$)\$(?!\$)/g, (match, content) => {
    return `$$${content}$$`;
  });



  // 8.5. Handle specific case: LaTeX expressions that are not within any delimiters

  // This is more targeted to catch the specific issue in lesson content

  processed = processed.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]+\}[^<]*?)(?=[<>]|$)(?!\$\$)/g, (match, content) => {
    // This specifically targets expressions like \mathbb{Q} = \Bigl{...}
    if (content.length > 20 && content.includes('=') && content.includes('\\Bigl{')) {
      return `$$${content}$$`;
    }
    return match;
  });



  // 8.6. Handle standalone LaTeX expressions that appear in text content
  // This catches expressions like \mathbb{Q} = \Bigl{\frac{p}{q} | p,q \in \mathbb{Z},; q \neq 0\Bigr}
  // that appear without any delimiters in the content

  processed = processed.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]*\}[^<]*?)(?=[<>]|$|\s|$)(?!\$\$)/g, (match, content) => {
    // Check if this looks like a complete mathematical expression
    const hasLaTeXCommands = /\\[a-zA-Z]+/.test(content);
    const hasMathOperators = /[=<>≤≥≠≈±×÷√^_(){}[\]|\\.,;:!?@#$%&*~`'"0-9a-zA-Z\s]/.test(content);
    const isSubstantial = content.length > 15;
    const hasBraces = content.includes('{') && content.includes('}');

    if (hasLaTeXCommands && hasMathOperators && isSubstantial && hasBraces) {
      return `$$${content}$$`;
    }
    return match;
  });

  // 8.6.1. More aggressive pattern for LaTeX expressions that might be missed
  // This catches expressions that appear in multi-line content or after colons

  processed = processed.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]*\}[^<]*?)(?=\n|$|$)(?!\$\$)/g, (match, content) => {
    // Check if this looks like a complete mathematical expression
    const hasLaTeXCommands = /\\[a-zA-Z]+/.test(content);
    const hasMathOperators = /[=<>≤≥≠≈±×÷√^_(){}[\]|\\.,;:!?@#$%&*~`'"0-9a-zA-Z\s]/.test(content);
    const isSubstantial = content.length > 15;
    const hasBraces = content.includes('{') && content.includes('}');

    if (hasLaTeXCommands && hasMathOperators && isSubstantial && hasBraces) {
      return `$$${content}$$`;
    }
    return match;
  });



  // 8.7. Handle LaTeX expressions that appear at the end of lines or paragraphs
  // This catches expressions that might be followed by line breaks or other content

  processed = processed.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]*\}[^<]*?)(?=\n|$|$)(?!\$\$)/g, (match, content) => {

    // Check if this looks like a complete mathematical expression
    const hasLaTeXCommands = /\\[a-zA-Z]+/.test(content);
    const hasMathOperators = /[=<>≤≥≠≈±×÷√^_(){}[\]|\\.,;:!?@#$%&*~`'"0-9a-zA-Z\s]/.test(content);
    const isSubstantial = content.length > 15;
    const hasBraces = content.includes('{') && content.includes('}');

    if (hasLaTeXCommands && hasMathOperators && isSubstantial && hasBraces) {
      return `$$${content}$$`;
    }
    return match;
  });


  // 8.8. Precise LaTeX expression wrapper - targets only the mathematical expression
  // This specifically targets expressions like \mathbb{Q} = \Bigl{...} and wraps only that part
  processed = processed.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]*\})(?=\s|$|\n)(?!\$\$)/g, (match, content) => {
    // This is a more precise pattern that only matches the LaTeX expression itself
    return `$$${content}$$`;
  });


  // 8.9. Alternative approach - process line by line to avoid matching too much content
  // Split content into lines and process each line individually

  const lines = processed.split('\n');
  const processedLines = lines.map(line => {
    // Only process lines that contain LaTeX expressions

    if (line.includes('\\mathbb{') && line.includes('\\Bigl{')) {
      return line.replace(/(?<![$\\])(?<!\$\$)(\\mathbb\{[^}]+\}\s*=\s*\\Bigl\{[^}]*\})(?=\s|$)(?!\$\$)/g, (match, content) => {
        return `$$${content}$$`;
      });
    }
    return line;
  });

  processed = processedLines.join('\n');



  // Second pass: Convert expressions with mathematical symbols and operations

  // Look for patterns that are clearly mathematical expressions

  processed = processed.replace(/(?<!\$)\$(?!\$)([^$\n]*[+\-*/=<>≤≥≠≈±×÷√^_(){}[\]|\\.,;:!?@#$%&*~`'"0-9a-zA-Z\s]+[^$\n]*)(?<!\$)\$(?!\$)/g, (match, content) => {

    // Skip if already converted to $$ or if it's just plain text

    if (content.includes('$$') || content.trim().length < 2) {

      return match;

    }



    // Skip if this would create mixed delimiters (contains $ inside)

    if (content.includes('$')) {

      return match;

    }





    // Skip single letter variables that are not part of mathematical expressions

    // But allow single digits to be converted to math expressions

    if (content.trim().length === 1 && /^[a-zA-Z]$/.test(content.trim())) {

      return match;

    }



    // Check if this looks like a mathematical expression

    const mathPatterns = [

      /[+\-*/=<>]/,

      /[0-9]/,

      /[a-zA-Z]\s*[+\-*/=<>]/,

      /[+\-*/=<>]\s*[a-zA-Z]/,

      /[a-zA-Z]\s*[0-9]/,

      /[0-9]\s*[a-zA-Z]/,

      /[(){}[\]^_]/,

      /[≤≥≠≈±×÷√]/,

      // Additional patterns for function notation and variables

      /[a-zA-Z]\s*\([^)]*\)/,  // f(x), g(y), etc.

      /[a-zA-Z]\s*[a-zA-Z]/,    // variable names

      /[a-zA-Z]\s*[0-9]/,       // x1, y2, etc.

      /[0-9]\s*[a-zA-Z]/,       // 2x, 3y, etc.

      /[a-zA-Z]\s*[+\-*/=<>]/,  // x =, y +, etc.

      /[+\-*/=<>]\s*[a-zA-Z]/,  // = x, + y, etc.

      // Percentage patterns

      /[0-9]+\s*%/,             // 75%, 12.5%, etc.

      /%/

    ];



    const isMathExpression = mathPatterns.some(pattern => pattern.test(content));



    if (isMathExpression) {

      return `$$${content}$$`;

    }



    return match;

  });



  // Third pass: Catch any remaining simple mathematical expressions

  // This is more aggressive and catches patterns that might have been missed

  processed = processed.replace(/(?<!\$)\$(?!\$)([^$\n]+)(?<!\$)\$(?!\$)/g, (match, content) => {

    // Skip if already converted to $$ or if it's just plain text

    if (content.includes('$$') || content.trim().length < 2) {

      return match;

    }



    // Skip if this would create mixed delimiters (contains $ inside)

    if (content.includes('$')) {

      return match;

    }



    // Skip if it's just plain text (no mathematical content)

    const hasMathContent = /[+\-*/=<>0-9a-zA-Z(){}[\]^_≤≥≠≈±×÷√]/.test(content);



    if (hasMathContent) {

      return `$$${content}$$`;

    }



    return match;

  });





  // 9. Handle LaTeX content inside square brackets [...]
  // This wraps LaTeX commands inside square brackets with $$ delimiters so they get processed
  processed = processed.replace(/\[([^[\]]*\\(?:begin|end|frac|sqrt|top|Longrightarrow|Leftarrow|Leftrightarrow|rightarrow|leftarrow|leftrightarrow|cases|pmatrix|vmatrix|bmatrix|matrix|align|equation|sum|int|lim|sin|cos|tan|log|ln|exp|alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Alpha|Beta|Gamma|Delta|Epsilon|Zeta|Eta|Theta|Iota|Kappa|Lambda|Mu|Nu|Xi|Pi|Rho|Sigma|Tau|Upsilon|Phi|Chi|Psi|Omega)[^[\]]*)\]/g, (match, content) => {
    // Only wrap if content contains LaTeX commands and isn't already wrapped in $$
    if (!content.includes('$$')) {
      return `$$${content}$$`;
    }
    return match;
  });




  // Handle \( \) notation first
  processed = processed.replace(
    /\\\(.*?\\\)/g,
    (match) => `$$${match.slice(2, -2)}$$`
  );




  // Process each LaTeX block
  const processLatexBlock = (latexBlock) => {
    if (!latexBlock.startsWith('$$') || !latexBlock.endsWith('$$')) {
      return latexBlock;

    }

    const latex = latexBlock.slice(2, -2);

    // Fix backslashes directly followed by digits within LaTeX blocks
    // Distinguish between matrix row separators and standalone digits
    let tempLatex = latex;

    // Fix backslashes followed by digits with a more reliable approach
    // Strategy: Use placeholders to protect matrix content, then process standalone digits

    const matrixPlaceholders = new Map();
    let placeholderCounter = 0;

    // First, extract all matrix blocks and replace them with placeholders
    const matrixRegex = /(\\begin\{(?:pmatrix|bmatrix|vmatrix|matrix|array)\}[\s\S]*?\\end\{(?:pmatrix|bmatrix|vmatrix|matrix|array)\})/g;
    tempLatex = tempLatex.replace(matrixRegex, (matrixMatch) => {
      const placeholder = `__MATRIX_PLACEHOLDER_${placeholderCounter++}__`;
      // Within matrix: \digit becomes \\digit (row separator with preserved digit)
      const processedMatrix = matrixMatch.replace(/\\(\d)/g, '\\\\$1');
      matrixPlaceholders.set(placeholder, processedMatrix);
      return placeholder;
    });



    // Now fix standalone \digit outside of matrix contexts (should become just digit)
    tempLatex = tempLatex.replace(/\\(\d)/g, '$1');

    // Finally, restore all matrix blocks
    matrixPlaceholders.forEach((processedMatrix, placeholder) => {
      tempLatex = tempLatex.replace(placeholder, processedMatrix);
    });

    // Check and format block matrices first - ADD THIS PART
    if (tempLatex.includes('\\begin{pmatrix}') &&
      (tempLatex.match(/\\begin{pmatrix}/g) || []).length > 1 &&
      tempLatex.includes(' & ')) {
      tempLatex = formatBlockMatrix(tempLatex);
    }

    // First, pre-process any differential evaluation bars before any placeholder substitution
    // This is critical - we handle this pattern explicitly BEFORE other processing
    tempLatex = escapeUnderscoresInText(tempLatex);

    // Extract and process \dfrac expressions with evaluation bars
    const dfractionWithEvalPattern = /(\\dfrac\{d(?:\^[^{}]+)?\}\{d[^{}]+(?:\^[^{}]+)?\}[^{}]*?\\mid_\{[^{}]*\})/g;
    const dfractions = [];

    tempLatex = tempLatex.replace(dfractionWithEvalPattern, (match, offset) => {
      const processedMatch = processDifferentialEvaluation(match);
      const placeholder = `__DFRAC_EVAL_${dfractions.length}__`;
      dfractions.push({
        placeholder,
        processed: processedMatch
      });
      return placeholder;
    });

    // Special patterns to preserve exactly as they are
    const specialDirectPreserve = [
      // Determinant notation with double braces
      /(\\text\{\{det\}\})/g,
      /(\\operatorname\{det\})/g,
      /(\\mathrm\{det\})/g,
      /(\\rightarrow)/g,
      /(\\leftarrow)/g,
      /(\\leftrightarrow)/g,
      /(\\Rightarrow)/g,
      /(\\Leftarrow)/g,
      /(\\Leftrightarrow)/g,
      /(\\longrightarrow)/g,
      /(\\longleftarrow)/g,
      /(\\longleftrightarrow)/g,
      /(-\>)/g,
      /(<-)/g,
      /(<->)/g,
    ];

    // Create a map for special direct preservation
    const specialPreserveMap = new Map();
    let specialCounter = 0;

    // First preserve the special patterns directly
    specialDirectPreserve.forEach(pattern => {
      tempLatex = tempLatex.replace(pattern, match => {
        const placeholder = `__SPECIAL_${specialCounter}__`;
        specialPreserveMap.set(placeholder, match);
        specialCounter++;
        return placeholder;
      });
    });

    // Enhanced patterns for nested structures
    const mathPatterns = [
      // Complex nested structures first
      // sqrt with potentially nested content
      /(\\sqrt\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,

      // All fraction types with potentially nested content
      /(\\(?:frac|dfrac|tfrac|cfrac|sfrac)\{(?:[^{}]|(?:\{[^{}]*\}))*\}\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,

      // Add this to your mathPatterns array
      /(\\binom\{(?:[^{}]|(?:\{[^{}]*\}))*\}\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,

      // Other commands with potentially nested content
      /(\\(?:sum|prod|int|lim)\_{(?:[^{}]|(?:\{[^{}]*\}))*\}\^{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,

      // Matrix environments
      /(\\begin\{[a-z]*matrix\}[\s\S]*?\\end\{[a-z]*matrix\})/gi,

      // Text commands
      /(\\text\{[^{}]*\})/g,

      // Subscripts and superscripts
      /([_^]\{(?:[^{}]|(?:\{[^{}]*\}))*\})/g,

      // General commands with one argument
      /(\\[a-zA-Z]+\{[^{}]*\})/g,

      // Other LaTeX environments
      /(\\begin\{[a-z]+\}[\s\S]*?\\end\{[a-z]+\})/gi,

      // Inline math commands with braces
      /(\\(?:mathbb|mathcal|mathfrak|mathscr|mathsf|mathtt)\{[^{}]*\})/g,

      // Arrow commands (as fallback if not caught by direct preserve)
      /(\\(?:rightarrow|leftarrow|leftrightarrow|Rightarrow|Leftarrow|Leftrightarrow|longrightarrow|longleftarrow|longleftrightarrow))/g,
    ];

    // Create a map to store replacements for regular patterns
    const preserveMap = new Map();
    let counter = 0;

    // Replace each math pattern with a placeholder - process multiple times for nested structures
    const maxPasses = 3; // Adjust based on expected nesting depth

    // for (let pass = 0; pass < maxPasses; pass++) {
    //   mathPatterns.forEach((pattern) => {
    //     tempLatex = tempLatex.replace(pattern, (match) => {
    //       const placeholder = `__PLACEHOLDER_${counter}__`;
    //       preserveMap.set(placeholder, match);
    //       counter++;
    //       return placeholder;
    //     });
    //   });
    // }



    // Process patterns in order of specificity (most specific first)
    mathPatterns.forEach((pattern) => {
      let hasMatches = true;

      // Keep processing until no more matches are found for this pattern
      while (hasMatches) {
        hasMatches = false;
        tempLatex = tempLatex.replace(pattern, (match) => {
          // Skip if this is already a placeholder
          if (match.startsWith('__PLACEHOLDER_') || match.startsWith('__SPECIAL_')) {
            return match;
          }

          hasMatches = true;
          const placeholder = `__PLACEHOLDER_${counter}__`;
          preserveMap.set(placeholder, match);
          counter++;
          return placeholder;
        });
      }
    });

    // Now process remaining evaluation bars on the simplified content
    tempLatex = processEvaluationBars(tempLatex);

    // Process set notation on the simplified content
    // tempLatex = tempLatex.replace(/(?<!\\)\{([^{}]*?)(?<!\\)\}/g, "\\{$1\\}");


    // Modified to only escape standalone curly braces, not those within LaTeX commands
    tempLatex = tempLatex.replace(/(?<![\\a-zA-Z\{])\{([^{}]*?)(?<!\\)\}/g, "\\{$1\\}");

    // Apply the standard replacements from the original code
    tempLatex = replaceMap(tempLatex);


    // Restore the preserved content - multiple passes to handle nested placeholders
    // First, restore our specially processed dfrac evaluation expressions
    dfractions.forEach(item => {
      tempLatex = tempLatex.replace(item.placeholder, item.processed);
    });

    // Then restore other preserved content
    let previousContent = "";
    let iterations = 0;
    const maxIterations = 10; // Prevent infinite loops

    while (previousContent !== tempLatex && iterations < maxIterations) {
      previousContent = tempLatex;
      iterations++;

      preserveMap.forEach((value, key) => {
        // Replace any placeholders that might be in the value first
        let updatedValue = value;
        preserveMap.forEach((innerValue, innerKey) => {
          if (updatedValue.includes(innerKey)) {
            updatedValue = updatedValue.replace(innerKey, innerValue);
          }
        });

        // Update the map
        preserveMap.set(key, updatedValue);

        // Replace in the main content
        tempLatex = tempLatex.replace(key, updatedValue);
      });
    }

    // Restore the special preserved content (like \text{{det}})
    specialPreserveMap.forEach((value, key) => {
      tempLatex = tempLatex.replace(key, value);
    });

    tempLatex = tempLatex.replace(/(?<!\\)\$/g, '\\$');


    return `$$${tempLatex}$$`;
  };

  // Split content into LaTeX and non-LaTeX parts
  const regex = /(\$\$.*?\$\$)/gs;
  const parts = processed.split(regex);



  // Process each part
  processed = parts.map((part, index) => {
    if (index % 2 === 1) { // LaTeX parts
      return processLatexBlock(part);
    }
    return part;
  }).join('');





  // Apply matrix processing if needed
  const hasMatrices = containsMatrix(processed) &&
    !processed.includes('\\\\[1ex]'); // Skip if already formatted

  if (hasMatrices) {
    processed = processMatrices(processed);
  }

  // Final step: Fix backslashes followed by digits
  // Strategy: Use placeholders to protect matrix content, then process standalone digits
  const matrixPlaceholders = new Map();
  let placeholderCounter = 0;

  // First, extract all matrix blocks and replace them with placeholders
  const matrixRegex = /(\\begin\{(?:pmatrix|bmatrix|vmatrix|matrix|array)\}[\s\S]*?\\end\{(?:pmatrix|bmatrix|vmatrix|matrix|array)\})/g;
  processed = processed.replace(matrixRegex, (matrixMatch) => {
    const placeholder = `__MATRIX_PLACEHOLDER_${placeholderCounter++}__`;
    // Within matrix: \digit becomes \\digit (row separator with preserved digit)
    // Use negative lookbehind to avoid matching \\digit (already processed)
    const processedMatrix = matrixMatch.replace(/(?<!\\)\\(\d)/g, '\\\\$1');
    matrixPlaceholders.set(placeholder, processedMatrix);
    return placeholder;
  });

  // Now fix standalone \digit outside of matrix contexts (should become just digit)
  // Use negative lookbehind to avoid matching \\digit (already processed)
  processed = processed.replace(/(?<!\\)\\(\d)/g, '$1');

  // Finally, restore all matrix blocks
  matrixPlaceholders.forEach((processedMatrix, placeholder) => {
    processed = processed.replace(placeholder, processedMatrix);
  });

  // Additional cleanup steps for common issues

  // 1. Fix backslashes before minus signs (\-x or \-5 should become -x or -5)
  processed = processed.replace(/\\(-[a-zA-Z0-9])/g, '$1');

  // 2. Fix triple backslashes with digits (\\\digit should become \\digit)
  processed = processed.replace(/\\\\\\(\d)/g, '\\\\$1');

  // 3. Fix any remaining standalone \digit patterns that might have been missed
  processed = processed.replace(/(?<!\\)\\(\d)/g, '$1');

  // 4. Fix mathematical function names that should be in \mathrm{}
  processed = processed.replace(/\\(rank|nullity|trace|dim|span|ker|im|det|adj)(?![a-zA-Z])/g, '\\mathrm{$1}');

  // Fix common units and physical constants that should be in \mathrm{}
  // processed = processed.replace(/\\text\{([^}]*)\b(atm|bar|Pa|kPa|MPa|torr|mmHg|psi|mol|kg|g|mg|L|mL|cm|mm|km|m|s|min|hr|h|K|°C|°F|J|kJ|cal|kcal|eV|W|kW|V|A|Ω|ohm|Hz|kHz|MHz|GHz)([^}]*)\}/g, '\\mathrm{$1$2$3}');

  // Fix common units and physical constants that should be in \mathrm{}
  processed = processed.replace(/\\text\{([^}]*\s)?(atm|bar|Pa|kPa|MPa|torr|mmHg|psi|mol|kg|g|mg|L|mL|cm|mm|km|m|s|min|hr|h|K|°C|°F|J|kJ|cal|kcal|eV|W|kW|V|A|Ω|ohm|Hz|kHz|MHz|GHz)(\s[^}]*)?\}/g, '\\mathrm{$1$2$3}');


  // 5. Additional safety: Fix cases where backslashes might have been stripped
  // This handles "mathrmrank" -> "\mathrm{rank}" type issues
  processed = processed.replace(/mathrm(rank|nullity|trace|dim|span|ker|im|det|adj)(?![a-zA-Z])/g, '\\mathrm{$1}');



  return processed;
}


function formatBlockMatrix(latexContent) {
  // Check if this is likely a block matrix pattern
  // Looking for nested matrices with row/column structure
  const isBlockMatrixPattern = (
    latexContent.includes('\\begin{pmatrix}') &&
    latexContent.includes('\\end{pmatrix}') &&
    latexContent.includes(' & ') &&
    latexContent.includes('\\\\') &&
    // Check for nested matrix pattern
    (latexContent.match(/\\begin{pmatrix}/g) || []).length > 1
  );

  if (!isBlockMatrixPattern) {
    return latexContent; // Not a block matrix format
  }

  // Add extra spacing after line breaks for better visual separation of rows
  let formattedLatex = latexContent;

  // For specifically 2×2 block matrices or similar structures,
  // replace regular line breaks with line breaks that include extra vertical space
  formattedLatex = formattedLatex.replace(/\\\\\s*/g, '\\\\[1ex]\n  ');

  // Add proper formatting with newlines for better structure
  formattedLatex = formattedLatex.replace('\\begin{pmatrix}', '\\begin{pmatrix}\n  ');
  formattedLatex = formattedLatex.replace('\\end{pmatrix}', '\n\\end{pmatrix}');

  // Make sure ampersands have proper spacing
  formattedLatex = formattedLatex.replace(/\s*&\s*/g, ' & ');

  return formattedLatex;
}

// Specialized function to process differential evaluation bars
function processDifferentialEvaluation(latexContent) {
  // Handle higher order differentials: \dfrac{d^n}{dx^n}f\mid_{x=a}
  return latexContent.replace(
    /(\\dfrac\{d(?:\^[^{}]+)?\}\{d[^{}]+(?:\^[^{}]+)?\})([^{}]*?)\\mid_\{([^{}]*)\}/g,
    "$1$2\\left.\\right|_{$3}"
  );
}

// Process other evaluation bars in simplified content
function processEvaluationBars(latexContent) {
  let processed = latexContent;

  // General case for any expression followed by \mid_{x=a}
  processed = processed.replace(
    /([^{}_\\])\\mid_\{([^{}]*)\}/g,
    "$1\\left.\\right|_{$2}"
  );

  // Handle isolated \mid
  processed = processed.replace(
    /(?<![\\a-zA-Z])\\mid(?![a-zA-Z_])/g,
    "\\middle|"
  );

  return processed;
}

// function formatLatexInHtmlTags(content) {
//   // First, decode HTML entities in the entire content
//   let processedContent = content
//     .replace(/&amp;/g, '&')
//     .replace(/&lt;/g, '<')
//     .replace(/&gt;/g, '>')
//     .replace(/&quot;/g, '"')
//     .replace(/&#39;/g, "'");

//   // This regex pattern finds HTML tags containing $$ delimiters
//   const tagWithLatexPattern = /<([a-z][a-z0-9]*)[^>]*>([^<]*\$\$.*?\$\$[^<]*)<\/\1>/gi;

//   // Process the content
//   return processedContent.replace(tagWithLatexPattern, (match, tag, innerContent) => {
//     // Check if innerContent contains LaTeX delimiters
//     if (innerContent.includes('$$')) {
//       // Process each LaTeX expression within the content
//       const processedInnerContent = innerContent.replace(/\$\$(.*?)\$\$/g, (latexMatch, latexContent) => {
//         // Create the properly formatted span for the LaTeX content
//         return `<span>$$${latexContent}$$</span>`;
//       });

//       // Return the original tag with the processed inner content
//       return `<${tag}>${processedInnerContent}</${tag}>`;
//     }

//     // If no LaTeX found, return the original match
//     return match;
//   });
// }


function formatLatexInHtmlTags(content) {
  // ── Step 1: Extract & protect ALL and  blocks ─────────────────
  // marked() correctly escapes TS/JSX generics as HTML entities inside code.
  // Decoding entities MUST NOT touch these blocks or DOMParser will treat
  // useState, , etc. as real DOM nodes → Lexical crash.
  const codeStore = [];

  let safeContent = content.replace(
    /]*>[\s\S]*?<\/pre>|]*>[\s\S]*?<\/code>/gi,
    (match) => {
      const token = `__CODE_${codeStore.length}__`;
      codeStore.push(match);
      return token;
    }
  );

  // ── Step 2: Decode HTML entities ONLY in non-code content ─────────────────
  safeContent = safeContent
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/"/g, '"')
    .replace(/'/g, "'");

  // ── Step 3: Process LaTeX inside HTML tags (non-code content only) ────────
  // Fixed regex: use [\s\S]*? instead of .*? to support multiline LaTeX blocks
  const tagWithLatexPattern =
    /<([a-z][a-z0-9]*)\b[^>]*>([^<]*\$\$[\s\S]*?\$\$[^<]*)<\/\1>/gi;

  safeContent = safeContent.replace(tagWithLatexPattern, (match, tag, innerContent) => {
    if (!innerContent.includes('$$')) return match;

    const processedInner = innerContent.replace(
      /\$\$([\s\S]*?)\$\$/g,
      (_, latex) => `$$${latex}$$`
    );

    return `<${tag}>${processedInner}`;
  });

  // ── Step 4: Restore protected code blocks exactly as they were ────────────
  safeContent = safeContent.replace(
    /__CODE_(\d+)__/g,
    (_, idx) => codeStore[Number(idx)]
  );

  return safeContent;
}

export { processLatex, formatLatexInHtmlTags };
